import axios from "axios";
import * as firebase from "firebase/app";
import "firebase/auth";
/* import { reject } from "lodash";
 */
const firebaseConfig = process.env.REACT_APP_ENV === "production" ? {
  apiKey: "AIzaSyBKZpEnYTnA-SSl9LVd2BwTS6dHW04jj20",
  authDomain: "gt-out.firebaseapp.com",
  databaseURL: "https://gt-out.firebaseio.com",
  projectId: "gt-out",
  storageBucket: "gt-out.appspot.com",
  messagingSenderId: "425061791221",
  appId: "1:425061791221:web:7e28f95527ee91f21fdcbc",
  measurementId: "G-GXJHQEBT3P",
} : {
  apiKey: "AIzaSyCdPRR9UZb2yjSj8HQYQYVwdJRxE7qVTxw",
  authDomain: "gto-mkt-dev.firebaseapp.com",
  projectId: "gto-mkt-dev",
  storageBucket: "gto-mkt-dev.appspot.com",
  messagingSenderId: "197781673670",
  appId: "1:197781673670:web:79ec6c65ad6f48f67929c7"
};
const app = firebase.initializeApp(firebaseConfig);
const auth = app.auth();
const base_path = process.env[`REACT_APP_${process.env.REACT_APP_ENV.toUpperCase()}_URL`] + "/v1/auth";


export const LOGIN_URL = "api/auth/login";
export const REGISTER_URL = "api/auth/register";
export const REQUEST_PASSWORD_URL = "api/auth/forgot-password";

export const ME_URL = "api/me";
export const GET_USER = base_path + "/VerifyToken";
export const UPDATE_USER = base_path + "/update/";
export const UPDATE_PWD = base_path + "/update-pwd/";

export function login(email, password) {
  return auth.signInWithEmailAndPassword(email, password);
}
export function update(payload) {
  return axios.post(UPDATE_USER + payload.uid, payload);
}
export function resetPassword(data) {
  const user = auth.currentUser;
  return new Promise((resolve, reject) => {
    if (typeof user.email !== "string") {
      reject("Email is not a string");
      return;
    } else {

      return auth.signInWithEmailAndPassword(user.email, data)
        .then(() => {
          resolve(auth.sendPasswordResetEmail(user.email))
        }).catch(() => {
          reject("Incorrect Credentials");
        })
    }
  });
}
export function register(email, fullname, username, password) {
  return axios.post(REGISTER_URL, { email, fullname, username, password });
}

export function requestPassword(email) {
  return auth.sendPasswordResetEmail(email);
}

export async function getUserByToken() {
  const token = await auth.currentUser.getIdToken();

  return new Promise((resolve, reject) => {
    axios.post(GET_USER, { token })
      .then((arg) => {
        resolve(arg)
      }).catch(async () => {

        reject("user doesnt found")
      })
  });


}